export const LIST_RECURRENCE: Record<number, string> = {
  12: 'Anual',
  6: 'Semestral',
  3: 'Trimestral',
  1: 'Mensal',
};

export const RECURRENCE_ANNUAL = 12;
